import React from "react";

function Footer() {
  return (
    <footer>
      <div className="bb ki xn gb bgset footer">
        <br/>
        {/* Footer Top */}
        <div className="gi">
          <div className="tc uf ap gg fp">
            <div className="animate_top zd/2 csfo">
                  {/* Video Logo */}
        <a href="/" className="logo">
          <video
            className="footerimglogo"
            src="/images/logo11.mp4"
            autoPlay
            muted
            loop
            playsInline
            loading="lazy"
          />
        </a>
              <p className="lc fb fwhite jutfy">
                Pinakinedge Media is a global leader in end-to-end B2B demand generation and performance marketing solutions. With over 15 years of expertise, we empower businesses to accelerate growth through high-quality, intent-driven leads and full-funnel marketing strategies.
              </p>

            

            </div>

              <div className="animate_top">
                <h4 className="mkwhit">Quick Links</h4>
                <ul className="fwhite">
                  <li><a href="/" className="sc xl vb">Home</a></li>
                  <li><a href="about" className="sc xl vb">About</a></li>
                  <li><a href="Careers" className="sc xl vb">Careers</a></li>
                  <li><a href="Contact" className="sc xl vb">Contact</a></li>
                  <li><a href="Faq" className="sc xl vb">FAQs</a></li>
                     <li><a href="Privacypolicy" className="sc xl vb">Privacy Policy</a></li>
                     <li><a href="dncpolicy" className="sc xl vb">DNC Policy</a></li>
                     <li><a href="gdprpolicy" className="sc xl vb">GDPR Policy</a></li>
                </ul>
              </div>

              <div className="animate_top">
                <h4 className="mkwhit">Services</h4>
                <ul className="fwhite">
                  <li><a href="Tofuemail">EMAIL MARKETING</a></li>
                    <li><a href="Tofuinent">INTENT DATA SERVICES</a></li>
                    <li><a href="Contentsyndi">CONTENT SYNDICATION</a></li>
                    <li><a href="Displaymarketing">DISPLAY MARKETING</a></li>
                  
                    <li><a href="Moumarketingqul">MARKETING QUALIFIED LEAD</a></li>
                    <li><a href="Mouhql">HIGHLY QUALIFIED LEAD</a></li>
                    <li><a href="Moubant">BUDGET, AUTHORITY, NEED, TIME</a></li>
                    <li><a href="Mouwebinar">WEBINAR</a></li>
                    
                    <li><a href="Bofuappoin">APPOINTMENT GENERATION</a></li>
                    <li><a href="Bofusql">SALES QUALIFIED LEADS</a></li>
                </ul>
              </div>

              <div className="animate_top">
                <h4 className="mkwhit">Contact Us</h4>
                <p className="contact-info">
  <a href="#!" className="contact-item fwhite">
  <img src="images/iconlocation.png" className="footerimg"></img>&nbsp;&nbsp;
  <span>4283 Express Ln, Suite IN7598, Sarasota, Florida 34249, US</span>
  </a>
  <a href="tel: 91 755 913 6688" className="contact-item fwhite">
  <img src="images/iconphone.png" className="footerimg"></img>&nbsp;&nbsp;
  <span> + 91 755 913 6688<br/></span>
  </a>
  <a href="tel: 1 912 620 9242" className="contact-item fwhite">
  <img src="images/iconphone.png" className="footerimg"></img>&nbsp;&nbsp;
  <span> +1 912 620 9242<br/></span>
  </a>
  <a href="tel:44 7465 796422" className="contact-item fwhite">
  <img src="images/iconphone.png" className="footerimg"></img>&nbsp;&nbsp;
  <span> +44 7465 796422</span>
  </a>
  <a href="mailto:info@pinakinedgemedia.com" className="contact-item fwhite">
  <img src="images/iconemail.png" className="footerimg"></img>&nbsp;&nbsp;
  <span>info@pinakinedgemedia.com</span>
  </a>
</p>
<br/>
  <div className="social-icons">
  {/* LinkedIn */}
  <a
    href="https://www.linkedin.com/company/pinakinedgemedia/about/?viewAsMember=true"
    target="_blank"
    rel="noreferrer"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className="social-icon"
    >
      <path d="M4.983 3.5C4.983 4.88 3.88 6 2.5 6C1.12 6 0 4.88 0 3.5C0 2.12 1.12 1 2.5 1C3.88 1 4.983 2.12 4.983 3.5ZM.2 8.6H4.8V24H.2V8.6ZM8.79 8.6H13.17V10.63H13.23C13.81 9.53 15.14 8.34 17.27 8.34C21.3 8.34 22 10.96 22 14.74V24H17.4V15.67C17.4 13.88 17.36 11.63 15.06 11.63C12.73 11.63 12.4 13.54 12.4 15.55V24H7.8V8.6H8.79Z" />
    </svg>
  </a>


</div>
{/* 
 <div className="animate_top">
   <div className="pm tc uf sf yo wf xf ap cg fp bj">
          <ul className="tc wf gg">
            <li> <img src="../images/iso27001.png" className="fticon"></img></li>
            <li> <img src="../images/iso9001.png" className="fticon"></img></li>
          </ul></div>
        </div> */}
             
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div  className="uf sf yo wf xf ap  bj">
         <center>
          
  <div className="footer-bottom">
    &copy; 2026 Pinakinedge Media. All rights reserved. &nbsp;|&nbsp; ISO 27001 &nbsp;|&nbsp; ISO 9001 &nbsp;|&nbsp; GDPR &nbsp;|&nbsp; Privacy Policy
  </div>
          </center>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
